import React from "react";

const BannerHTMLComponent = ({ playlist, title }) => {
    const bannerContent = playlist[0]?.codigo_html ?? null;

    if (!bannerContent) {
        return null;
    }

    return (
        <div>
            <div dangerouslySetInnerHTML={{__html: bannerContent}}/>
        </div>
    )
}

export default BannerHTMLComponent;
